import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'documator';
export const documatorServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const DocumatorServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: documatorServiceEventType(),
}));
